import React, {Dispatch, SetStateAction} from 'react';
import {Alert, AlertColor, Stack} from '@mui/material';

interface CustomAlertProps {
  isActive: boolean;
  severity: AlertColor;
  errorMessage: string;
  setIsActive: Dispatch<SetStateAction<boolean>>;
}
export const CustomAlert: React.FC<CustomAlertProps> = ({severity, errorMessage, isActive, setIsActive}) => {
  return (
    <Stack direction="row">
      {isActive && (
        <Alert
          sx={{paddingBottom: '10px'}}
          severity={severity}
          onClose={() => {
            setIsActive(false);
          }}
        >
          {errorMessage}
        </Alert>
      )}
    </Stack>
  );
};

export default CustomAlert;
